import { render } from "./FormatListing.vue?vue&type=template&id=3b5201ca"
import script from "./FormatListing.vue?vue&type=script&lang=js"
export * from "./FormatListing.vue?vue&type=script&lang=js"
script.render = render

export default script